import { Component, Input, OnInit } from '@angular/core';
import {
  DEFAULT_APPLICATION_PHONE_NUMBER,
  ROCKET_MORTGAGE_CLOSING_TEAM_NUMBER,
} from 'src/app/features/shared/constants';
import { FaqWidgetService } from 'src/app/features/help-faq';
import { FeatureManagementService } from 'src/app/features/feature-management/services';
import { Feature } from 'src/app/features/feature-management/models';
import { Store } from '@ngrx/store';
import { getHasAssociatedUsersAndPackage } from 'src/app/features/help-faq/store/selectors/help-faq.selectors';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
    selector: 'app-support-phone-number-button',
    templateUrl: './support-phone-number-button.component.html',
    styleUrls: ['../../nav-bar.component.scss'],
    standalone: false
})
export class SupportPhoneNumberButtonComponent implements OnInit {
  @Input() showPhoneNumber = true;
  techSupportNumber = DEFAULT_APPLICATION_PHONE_NUMBER;
  documentAndLoanNumber = ROCKET_MORTGAGE_CLOSING_TEAM_NUMBER;

  protected readonly hasAssociatedUsersAndPackage = this.store.selectSignal(getHasAssociatedUsersAndPackage);
  protected isFaqEnabled = false;

  constructor(
    private readonly faqWidgetService: FaqWidgetService,
    private readonly featureManagementService: FeatureManagementService,
    private readonly store: Store
  ) {}

  ngOnInit(): void {
    const cached = this.featureManagementService.getIsFeatureEnabledWithCaching(Feature.HelpFaqWidget);
    const flag$ = cached !== undefined
      ? of(cached)
      : this.featureManagementService.getIsFeatureFlagEnabled(Feature.HelpFaqWidget).pipe(
          catchError(() => of(false)),
        );
    flag$.subscribe((enabled) => {
      this.isFaqEnabled = enabled;
    });
  }

  get showFaqButton(): boolean {
    return this.hasAssociatedUsersAndPackage() && this.isFaqEnabled;
  }

  openFaqs(): void {
    this.faqWidgetService.open();
  }

  /** Builds a tel: href from a display-formatted phone number. */
  telHref(phoneNumber: string): string {
    return 'tel:' + phoneNumber.replace(/[^\d+]/g, '');
  }
}
